import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Button, I } from '@leanin/ui';
import { FlowShell, type FlowStep } from '@/components/onboarding/FlowShell';
import {
  ChecklistColumn,
} from '@/components/onboarding/ChecklistColumn';
import { clearStoredPersona } from '@/components/onboarding/persona';
import { clearPendingInviteToken } from '@/components/onboarding/pending-invite';
import { useCompleteOnboarding } from '@/lib/mutations/identity';
import { STEP_CONTENT_BY_KEY } from '@/components/onboarding/checklist-registry';
import { PERSONA_STEP_KEYS } from '@/components/onboarding/persona-steps';

const STEPS: ReadonlyArray<FlowStep> = [
  { label: 'Welcome' },
  { label: 'Lean In Circles' },
  { label: 'Get involved' },
  { label: 'Build leadership skills' },
  { label: "You're in" },
];

export const Route = createFileRoute('/onboarding/complete')({
  component: OnboardingCompletePage,
});

function OnboardingCompletePage() {
  const navigate = useNavigate();
  const completeOnboarding = useCompleteOnboarding();
  const finish = async (to: string = '/feed') => {
    try {
      await completeOnboarding.mutateAsync({ persona: 'li' });
    } catch {
      // Swallow — the user clicking "Take me in" shouldn't be blocked by
      // a transient flag-write failure. If it persists the user will
      // simply see onboarding again next sign-in.
    }
    clearStoredPersona();
    clearPendingInviteToken();
    navigate({ to: to as '/' });
  };
  return (
    <FlowShell
      role="Lean In Member"
      stepIndex={4}
      steps={STEPS}
      title="Let's get started."
      primary={
        <Button variant="primary" icon={I.arrow} onClick={() => void finish()}>
          Take me in
        </Button>
      }
      secondary={
        <Button
          variant="ghost"
          onClick={() => navigate({ to: '/onboarding/welcome' })}
        >
          Return to welcome message
        </Button>
      }
    >
      <ChecklistColumn
        eyebrow="Next steps"
        title="Your Lean In Member Checklist"
        items={PERSONA_STEP_KEYS['lean-in'].map((key) => {
          const { title, sub, cta, href } = STEP_CONTENT_BY_KEY[key];
          return { title, sub, cta, href };
        })}
        onNavigate={(href) => void finish(href)}
      />
    </FlowShell>
  );
}
